import React, { useEffect, useState } from "react";
import axios from "axios";
import MainLayout from "../../../layout/MainLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFilter } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../Auths/CheckUser";

const ActiveTable = () => {
    const { user } = useAuth();
    const [clients, setClients] = useState([]);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(true);

    //  Filter states
    const [showFilters, setShowFilters] = useState(false);
    const [search, setSearch] = useState("");
    const [zoneFilter, setZoneFilter] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    //  Fetch clients assigned to the logged-in user
    useEffect(() => {
        if (!user?.id) return;
        const fetchClients = async () => {
            try {
                const res = await axios.get(`https://bpohasil.ngrok.app/api/user/${user.id}`);
                const userClients = res.data?.airclients || [];
                setClients(userClients);
            } catch (err) {
                console.error("Error fetching user clients:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchClients();
    }, [user]);

    //  Filter only ACTIVE clients
    const activeClients = clients.filter(
        (client) =>
            client.status?.toLowerCase() === "aktif" ||
            client.status?.toLowerCase() === "active"
    );

    //  Apply search and date filters
    const filteredClients = activeClients.filter((client) => {
        const matchesSearch =
            client.name?.toLowerCase().includes(search.toLowerCase()) ||
            client.identificationNumber
                ?.toLowerCase()
                .includes(search.toLowerCase());

        const matchesZone = zoneFilter ? client.zoneId === zoneFilter : true;

        const matchesDate =
            (!startDate ||
                new Date(client.createdAt) >= new Date(startDate)) &&
            (!endDate || new Date(client.createdAt) <= new Date(endDate));

        return matchesSearch && matchesZone && matchesDate;
    });

    //  Calculate total collection (paymentAmount)
    const totalCollection = filteredClients.reduce(
        (sum, item) => sum + (parseFloat(item.paymentAmount) || 0),
        0
    );

    //  Unique zones for dropdown
    const uniqueZones = [...new Set(activeClients.map((c) => c.zoneId))];

    if (loading) {
        return (
            <MainLayout>
                <div className="flex justify-center items-center h-screen text-xl font-semibold">
                    Loading active clients...
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div className="bg-white p-3 md:p-5">
                <div className="flex justify-between items-center mb-3">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-800 text-center w-full">
                        ACTIVE paymentAmount COLLECTION REPORT
                    </h2>
                </div>

                {/* 🔘 Filter Button */}
                <div className="flex justify-end mb-4">
                    <button
                        onClick={() => setShowFilters(!showFilters)}
                        className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition"
                    >
                        <FontAwesomeIcon icon={faFilter} />
                        {showFilters ? "Hide Filters" : "Show Filters"}
                    </button>
                </div>

                {/* 🔍 Filters */}
                {showFilters && (
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 grid grid-cols-1 md:grid-cols-4 gap-4 animate-fadeIn">
                        <input
                            type="text"
                            placeholder="Search by Name or IC..."
                            className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <select
                            className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={zoneFilter}
                            onChange={(e) => setZoneFilter(e.target.value)}
                        >
                            <option value="">All Zones</option>
                            {uniqueZones.map((zone, index) => (
                                <option key={index} value={zone}>
                                    Zone {zone}
                                </option>
                            ))}
                        </select>
                        <label className="">From</label>
                        <input
                            type="date"
                            className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                        <label className="">To</label>
                        <input
                            type="date"
                            className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                )}

                {/*  Summary */}
                <div className="bg-green-100 border border-green-300 rounded-xl p-4 mb-5 shadow-sm text-center flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-10">
                    <div>
                        <p className="text-gray-700 font-medium text-sm md:text-base">
                            Total Active Users Collection
                        </p>
                        <h3 className="text-xl md:text-2xl font-bold text-green-700 mt-1">
                            RM{" "}
                            {totalCollection.toLocaleString("en-MY", {
                                minimumFractionDigits: 2,
                            })}
                        </h3>
                    </div>
                    <div className="w-[1px] h-10 bg-green-300 hidden sm:block"></div>
                    <div>
                        <p className="text-gray-700 font-medium text-sm md:text-base">
                            Number of Active Users
                        </p>
                        <h3 className="text-xl md:text-2xl font-bold text-green-700 mt-1">
                            {filteredClients.length}
                        </h3>
                    </div>
                </div>

                {/*  Active Clients Table */}
                <div className="overflow-x-auto">
                    <table className="w-full text-sm border border-gray-200">
                        <thead className="bg-gray-100 text-gray-700 uppercase text-xs md:text-sm">
                            <tr>
                                <th className="px-2 py-2 border text-center">#</th>
                                <th className="px-2 py-2 border">Name</th>
                                <th className="px-2 py-2 border">Area</th>
                                <th className="px-2 py-2 border text-right">Paymnet</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredClients.length > 0 ? (
                                filteredClients.map((item, index) => (
                                    <tr
                                        key={item.id || index}
                                        onClick={() => setSelected(item)}
                                        className="hover:bg-gray-50 cursor-pointer even:bg-gray-50 text-gray-800 transition"
                                    >
                                        <td className="px-2 py-2 border text-center">{index + 1}</td>
                                        <td className="px-2 py-2 border truncate">{item.name}</td>
                                        <td className="px-2 py-2 border truncate">{item.rentalArea || "-"}</td>
                                        <td className="px-2 py-2 border text-right">
                                            RM {item.paymentAmount?.toLocaleString() || "0.00"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-gray-500 italic">
                                        No active clients found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/*  Popup Modal */}
                {selected && (
                    <div
                        className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-2"
                        onClick={() => setSelected(null)}
                    >
                        <div
                            className="bg-white w-full max-w-md md:max-w-2xl rounded-lg shadow-lg relative p-4 overflow-y-auto max-h-[90vh]"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-2xl"
                                onClick={() => setSelected(null)}
                            >
                                <FontAwesomeIcon icon={faClose} className="text-red-500" />
                            </button>

                            <h3 className="text-base md:text-lg font-semibold text-center mb-3 text-gray-800">
                                Active Client Details
                            </h3>

                            <div className="text-sm space-y-1">
                                <p><strong>ID:</strong> {selected.id}</p>
                                <p><strong>Account Number:</strong> {selected.accountNumber}</p>
                                <p><strong>Name:</strong> {selected.name}</p>
                                <p><strong>Area Code:</strong> {selected.areaCode}</p>
                                <p><strong>Area Name:</strong> {selected.areaName}</p>
                                <p><strong>Unit Number:</strong> {selected.unitNumber}</p>
                                <p><strong>Account No:</strong> {selected.accountNo}</p>
                                <p><strong>Unit Address:</strong> {selected.unitAddress}</p>
                                <p><strong>Payment Amount:</strong> RM {(Number(selected.paymentAmount) || 0).toLocaleString()}</p>
                                <p><strong>Arrears:</strong> RM {(Number(selected.arrears) || 0).toLocaleString()}</p>
                                <p><strong>Collection Center:</strong> {selected.collectionCenter}</p>
                                <p><strong>Receipt Number:</strong> {selected.receiptNumber}</p>
                                <p><strong>Receipt Date:</strong> {new Date(selected.receiptDate).toLocaleString()}</p>
                                <p><strong>Status:</strong> {selected.status}</p>
                                <p><strong>Contract Type:</strong> {selected.contractType}</p>
                                <p><strong>Contract Start Date:</strong> {new Date(selected.contractStartDate).toLocaleDateString()}</p>
                                <p><strong>Contract End Date:</strong> {new Date(selected.contractEndDate).toLocaleDateString()}</p>
                                <p><strong>Created At:</strong> {new Date(selected.createdAt).toLocaleString()}</p>
                                <p><strong>Updated At:</strong> {new Date(selected.updatedAt).toLocaleString()}</p>

                                {selected.contractImage && (
                                    <div className="mt-2">
                                        <strong>Contract Image:</strong>
                                        <img
                                            src={`https://bpohasil.ngrok.app${selected.contractImage}`}
                                            alt="Contract"
                                            className="mt-1 rounded-lg border w-60"
                                        />
                                    </div>
                                )}
                            </div>


                        </div>
                    </div>
                )}
            </div>
        </MainLayout>
    );
};

export default ActiveTable;
